import { Modal } from '@mui/material'
import { ControllerBatteryGuide } from './controllerBatteryGuide'
import { TrackerBatteryGuide } from './trackerBatteryGuide'
import { SensorBatteryGuide } from './sensorBatteryGuide'
import View from '@modul-connect/shared/components/atoms/view'
import Button from '@modul-connect/shared/components/atoms/button'
import theme from '@modul-connect/shared/theme'

export const BatteryGuideModal = ({ openKey, onClose }) => {
  const content = {
    sensors: <SensorBatteryGuide />,
    controllers: <ControllerBatteryGuide />,
    trackers: <TrackerBatteryGuide />,
  }

  const titles = {
    sensors: 'How to change battery',
    trackers: 'How to change battery - Alarm sensor',
    controllers: 'How to change battery - Remote control',
  }

  return (
    <Modal open={!!openKey} onClose={onClose}>
      <View
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 598,
          display: 'flex',
          flexDirection: 'column',
          padding: '42px 34px',
          background: theme.colors.barBackground,
        }}
      >
        <View
          style={{
            paddingBottom: '8px',
            background: theme.colors.barBackground,
            boxShadow: 'none',
          }}
        >
          <View
            style={{
              fontFamily: 'Inter',
              fontWeight: 500,
              fontSize: 16,
              lineHeight: '19px',
              color: theme.colors.midDarkGrey,
            }}
          >
            {titles[openKey] ?? 'How to change battery'}
          </View>
        </View>

        <View
          style={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0,
            background: theme.colors.white,
            borderRadius: '0 0 8px 8px',
            ...theme.shadowStylePaper,
            overflow: 'hidden',
          }}
        >
          
          <View
            style={{
              flex: 1,
              overflowY: 'auto'
            }}
          >
            {content[openKey] ?? null}
          </View>

          <span style={{
            margin: '0 24px 0 24px',
            borderTop: `0.5px solid ${theme.colors.simpleButtonBorder}`,
          }}>
      
          </span>
          <View
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              margin: '16px 24px 24px 24px',
            }}
          >
            <Button
              noBg
              onClick={onClose}
              extend={{
                padding: '8px 20px',
                border: `1px solid ${theme.colors.midDarkGrey}`,
                color: theme.colors.midDarkGrey,
              }}
            >
              Got it
            </Button>
          </View>
        </View>
      </View>
    </Modal>
  )
}
